import type { Marke } from '../../api/client';

/** Text mit hervorgehobenen Suchbegriffen. Die Marken kommen vom Backend (Positionen in UTF-16, wie JavaScript zählt). */
export default function Markiert({ text, marken }: { text: string; marken: Marke[] }) {
  if (!marken.length) return <>{text}</>;
  const teile: React.ReactNode[] = [];
  let pos = 0;
  [...marken].sort((a, b) => a[0] - b[0]).forEach(([s, e], i) => {
    if (s < pos || e > text.length) return;
    if (s > pos) teile.push(text.slice(pos, s));
    teile.push(<mark key={i} className="rounded-sm bg-amber-200/80 px-px text-inherit">{text.slice(s, e)}</mark>);
    pos = e;
  });
  if (pos < text.length) teile.push(text.slice(pos));
  return <>{teile}</>;
}
